import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAddressAutoUpdatedCount = {
  name: "getAddressAutoUpdatedCount" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
